import { render, staticRenderFns } from "./SMSOrderModal.vue?vue&type=template&id=2af1cd4b"
import script from "./SMSOrderModal.vue?vue&type=script&lang=js"
export * from "./SMSOrderModal.vue?vue&type=script&lang=js"
import style0 from "./SMSOrderModal.vue?vue&type=style&index=0&id=2af1cd4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports